import { useState, useEffect } from 'react';
import { useCachedBlobUrl } from '../../Services/useBlobDownloader';

export const FileAttachment = ({ file, onDelete }) => {
  const [fileUrl, setFileUrl] = useState(file?.url || null);
  const { getCachedBlobUrl } = useCachedBlobUrl();

  useEffect(() => {
    if (fileUrl) return;

    const fileKey = file?.key;
    if (!fileKey) return;

    const ac = new AbortController();

    (async () => {
      try {
        const blobUrl = await getCachedBlobUrl(fileKey, 'file', { signal: ac.signal });
        setFileUrl(blobUrl);
      } catch (err) {
        if (err.name !== 'AbortError') {
          console.error(`Error loading file with key ${fileKey}:`, err);
        }
      }
    })();

    return () => ac.abort();
  }, [file?.key, getCachedBlobUrl]);

  const handleDelete = () => {
    if (onDelete && file?.key) onDelete(file.key);
  };

  const fileName = file?.fileName || file?.name || 'unknown';
  const extension = (fileName?.split('.').pop() || '').toLowerCase();
  const size = file?.size || '';
  const isLoading = !fileUrl;

  return (
    <div className={`file-wrapper file-${extension}`}>
      {isLoading ? (
        <div
          className="is-loading"
          aria-busy="true"
          aria-disabled="true"
          title="Loading…"
          style={{
            pointerEvents: 'none',
            left: '-30px',
            position: 'absolute',
          }}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 50 50"
            style={{
              position: 'absolute',
              pointerEvents: 'none',
            }}
          >
            <circle
              cx="25"
              cy="25"
              r="20"
              fill="none"
              stroke="currentColor"
              strokeWidth="6"
              strokeLinecap="round"
              strokeDasharray="31.4 188.4"
            >
              <animateTransform
                attributeName="transform"
                type="rotate"
                from="0 25 25"
                to="360 25 25"
                dur="0.9s"
                repeatCount="indefinite"
              />
            </circle>
          </svg>
        </div>
      ) : (
        <a
          className="file-download-link"
          href={fileUrl}
          download={fileName}
          aria-label="Download file"
        />
      )}

      <div className="file-info">
        <div className="file-name">{fileName}</div>
        <div className="file-creds">
          <span className="file-ext">{extension}</span>
          <span>Document</span>
          <span className="file-separator"></span>
          {size && (
            <>
              <span className="file-size">{size}</span>
              <span>MB</span>
            </>
          )}
        </div>
      </div>
      <div className="file-icon-wrapper">
        <div className="file-icon"></div>

        {onDelete && (
          <button type="button" className="file-remove-btn-inside-icon" onClick={handleDelete}>
            ✕
          </button>
        )}
      </div>
    </div>
  );
};
